var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23431 6.53632C4.54673 6.2239 5.05327 6.2239 5.36569 6.53632L8 9.17063L10.6343 6.53632C10.9467 6.2239 11.4533 6.2239 11.7657 6.53632C12.0781 6.84874 12.0781 7.35527 11.7657 7.66769L8.56569 10.8677C8.25327 11.1801 7.74673 11.1801 7.43431 10.8677L4.23431 7.66769C3.9219 7.35527 3.9219 6.84874 4.23431 6.53632Z",
    fill: "#92400E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBrown);
export default __webpack_public_path__ + "static/media/DownArrow_brown.e2ca161bb1688cddb0460dfd3ae1501b.svg";
export { ForwardRef as ReactComponent };